module.exports = __webpack_public_path__ + "img/coinflip_animation.49acb705.gif";